import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteIcon = _resolveComponent("SiteIcon")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    split: "",
    flat: "",
    "no-caps": "",
    class: _normalizeClass([_ctx.isActive ? '' : 'text-grey-5', "site-category-chip"]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-platform')))
  }, {
    label: _withCtx(() => [
      _createVNode(_component_SiteIcon, {
        "social-site": _ctx.platform,
        color: _ctx.isActive ? '' : 'grey-5',
        size: "sm",
        class: "q-mr-xs"
      }, null, 8, ["social-site", "color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_list, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item, {
            clickable: "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('toggle-all')), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_checkbox, {
                    "model-value": _ctx.allSelected,
                    dense: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-all')))
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, { class: "text-weight-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" All Post Types ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
            return (_openBlock(), _createBlock(_component_q_item, {
              key: category.id,
              clickable: "",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('toggle-category', category.id)), ["stop"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_checkbox, {
                      "model-value": _ctx.allSelected || _ctx.selectedCategoryIds.includes(category.id),
                      dense: "",
                      "onUpdate:modelValue": ($event: any) => (_ctx.$emit('toggle-category', category.id))
                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(category.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          _renderSlot(_ctx.$slots, "append")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}